import { $axios } from '@/shared/api';

export const validateRoomId = (roomId) => {
  return $axios.get(`twilio-video/room/${roomId}`);
};
